const GA_MEASUREMENT_ID = 'G-PZ5P1L69E5';

const GA_EVENT = {
  EXPLORE_PAGE_VIEW: 'explore_page_view',
  PERSONALISATION_PERSONALISE_NOW_CLICK:
    'personalisation_personalise_now_click',
  PERSONALISATION_SUBMIT: 'personalisation_submit',
  PERSONALISATION_RE_SUBMIT: 'personalisation_re_submit',
  PERSONALISATION_UPDATE_CLICK: 'personalisation_update_click',
  PERSONALISATION_LINK_CLICK: 'personalisation_link_click',
  EXPLORE_FILTER_CLICK: 'explore_filter_click',
};

export const buildPersonaCombination = (questionResponses) => {
  if (!questionResponses || Object.keys(questionResponses).length === 0) {
    return null;
  }

  return Object.entries(questionResponses)
    .sort(([questionIdA], [questionIdB]) =>
      questionIdA.localeCompare(questionIdB)
    )
    .map(([questionId, answers]) => {
      const sortedAnswers = [...answers].sort();
      return `${questionId}:${sortedAnswers.join(',')}`;
    })
    .join('|');
};

const isLocalEnv = () => import.meta.env.VITE_ENV === 'local';

const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    if (isLocalEnv()) {
      console.warn('[analytics] gtag unavailable, skipped:', eventName, params);
    }
    return;
  }

  if (isLocalEnv()) {
    console.info('[analytics]', eventName, params);
  }

  window.gtag('event', eventName, params);
};

const enableDebugMode = () => {
  if (typeof window.gtag !== 'function') {
    return false;
  }

  window.gtag('config', GA_MEASUREMENT_ID, { debug_mode: true });
  return true;
};

export const initAnalytics = (env) => {
  if (env !== 'local') {
    return;
  }

  if (enableDebugMode()) {
    return;
  }

  window.addEventListener('load', enableDebugMode, { once: true });
};

export const trackExplorePageView = () => {
  trackEvent(GA_EVENT.EXPLORE_PAGE_VIEW);
};

export const trackPersonaliseNowClick = () => {
  trackEvent(GA_EVENT.PERSONALISATION_PERSONALISE_NOW_CLICK);
};

export const trackPersonalisationSubmit = ({
  personaCombination,
  submittedAt,
}) => {
  trackEvent(GA_EVENT.PERSONALISATION_SUBMIT, {
    persona_combination: personaCombination,
    submitted_at: submittedAt,
  });
};

export const trackPersonalisationReSubmit = ({
  personaCombination,
  previousPersonaCombination,
  submittedAt,
}) => {
  trackEvent(GA_EVENT.PERSONALISATION_RE_SUBMIT, {
    persona_combination: personaCombination,
    previous_persona_combination: previousPersonaCombination ?? undefined,
    submitted_at: submittedAt,
  });
};

export const trackUpdatePersonalisationClick = ({
  personaCombination,
  clickedAt,
}) => {
  trackEvent(GA_EVENT.PERSONALISATION_UPDATE_CLICK, {
    persona_combination: personaCombination,
    clicked_at: clickedAt,
  });
};

export const trackPersonalisationLinkClick = ({
  linkId,
  linkName,
  linkType,
  url,
  clickedAt,
  personaCombination,
  personalisationRelevance,
}) => {
  trackEvent(GA_EVENT.PERSONALISATION_LINK_CLICK, {
    link_id: linkId,
    link_name: linkName,
    link_type: linkType,
    link_url: url,
    clicked_at: clickedAt,
    persona_combination: personaCombination ?? undefined,
    personalisation_relevance: personalisationRelevance ?? undefined,
  });
};

export const trackExploreFilterClick = ({
  filterValue,
  filterType,
  clickedAt,
  personaCombination,
}) => {
  trackEvent(GA_EVENT.EXPLORE_FILTER_CLICK, {
    filter_value: filterValue,
    filter_type: filterType ?? undefined,
    clicked_at: clickedAt,
    persona_combination: personaCombination ?? undefined,
  });
};
